export const projectSchemaImportOptionalProps = ['projectId', 'locales', 'defaultLocale', 'author'];
export const legacyProjectSchemaImportOptionalProps = ['created', 'updated', 'version', 'dataKey'];
/**
 * Types of args
 */
export var ArgsType;
(function (ArgsType) {
    ArgsType["@args"] = "@args";
    ArgsType["args"] = "args";
})(ArgsType || (ArgsType = {}));
